/**
 * Toggle new step-1 booking UI per slug.
 * Set REACT_APP_NEW_STEP1_UI=true in .env to enable for all branches.
 */
const NEW_STEP1_UI_SLUGS: string[] = [""];

export const shouldUseNewStep1Ui = (slug?: string): boolean => {
  if (process.env.REACT_APP_NEW_STEP1_UI === "true") {
    return true;
  }
  if (!slug) return false;
  return NEW_STEP1_UI_SLUGS.includes(slug);
};
